/* eslint-disable react/prop-types */
import React from 'react'
import { scaleLinear } from 'd3-scale'

export default function StrikeZone({ settings, chartOptions = {} }) {
    const x = scaleLinear().range([0, settings.vizWidth]).domain([-4, 4])
    let y = scaleLinear().range([settings.vizHeight, 0]).domain([-1, 6])

    let x1 = x(-0.70833)
    let width = x(0.70833) - x(-0.70833)
    let y1 = y(3.5)
    let height = y(1.5) - y(3.5)

    if (settings.strikeZoneDefinition === 'relative') {
        y = scaleLinear().range([settings.vizHeight, 0]).domain([-4, 4])

        x1 = x(-1)
        width = x(1) - x(-1)
        y1 = y(1)
        height = y(-1) - y(1)
    }

    const styles = {
        fill: chartOptions.strikeZoneFill || null,
        stroke: chartOptions.strikeZoneStroke || '#000',
    }

    return (
        <g id="strikeZone">
            <rect
                className="strike-zone"
                x={x1}
                width={width}
                y={y1}
                height={height}
                fillOpacity={chartOptions.strikeZoneFillOpacity || 0.001}
                strokeOpacity={chartOptions.strikeZoneBorderOpacity || 1}
                style={styles}
            />
        </g>
    )
}
